import { requestScrollLock, releaseScrollLock } from "../lib/scroll-lock.js";

class CartOverlay extends HTMLElement {
  connectedCallback() {
    this.backdrop = this.querySelector("[data-cart-backdrop]");
    this.panel = this.querySelector("[data-cart-panel]");
    this.toggleBtn = document.querySelector("[data-cart-toggle]");
    this.closeBtns = this.querySelectorAll("[data-cart-close]");
    this.isOpen = false;

    this._onToggleClick = () => this.toggle();
    this._onBackdropClick = () => this.close();
    this._onKeyDown = (e) => {
      if (e.key === "Escape" && this.isOpen) this.close();
    };
    this._onRemoveClick = (e) => {
      const btn = e.target.closest("[data-remove-item]");
      if (!btn) return;
      e.preventDefault();
      const currentQty = parseInt(btn.dataset.itemQuantity, 10) || 1;
      this._removeItem(btn.dataset.removeItem, currentQty - 1);
    };

    this.toggleBtn?.addEventListener("click", this._onToggleClick);
    this.backdrop?.addEventListener("click", this._onBackdropClick);
    this.closeBtns.forEach((btn) => btn.addEventListener("click", this._onBackdropClick));
    document.addEventListener("keydown", this._onKeyDown);
    this.addEventListener("click", this._onRemoveClick);

    this._checkUrlParam();
  }

  disconnectedCallback() {
    this.toggleBtn?.removeEventListener("click", this._onToggleClick);
    this.backdrop?.removeEventListener("click", this._onBackdropClick);
    this.closeBtns.forEach((btn) => btn.removeEventListener("click", this._onBackdropClick));
    document.removeEventListener("keydown", this._onKeyDown);
    this.removeEventListener("click", this._onRemoveClick);
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.backdrop?.classList.remove("opacity-0", "pointer-events-none");
    this.backdrop?.classList.add("opacity-100", "pointer-events-auto");
    this.panel?.classList.remove("opacity-0", "pointer-events-none", "-translate-y-2");
    this.panel?.classList.add("opacity-100", "pointer-events-auto", "translate-y-0");
    this.panel?.removeAttribute("inert");
    this.panel?.removeAttribute("aria-hidden");
    this.toggleBtn?.setAttribute("aria-expanded", "true");
    requestScrollLock("cart-overlay");
  }

  close() {
    this.isOpen = false;
    this.backdrop?.classList.remove("opacity-100", "pointer-events-auto");
    this.backdrop?.classList.add("opacity-0", "pointer-events-none");
    this.panel?.classList.remove("opacity-100", "pointer-events-auto", "translate-y-0");
    this.panel?.classList.add("opacity-0", "pointer-events-none", "-translate-y-2");
    this.panel?.setAttribute("inert", "");
    this.panel?.setAttribute("aria-hidden", "true");
    this.toggleBtn?.setAttribute("aria-expanded", "false");
    releaseScrollLock("cart-overlay");
  }

  async _removeItem(key, quantity = 0) {
    try {
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!res.ok) throw new Error(res.statusText);
      await this._refreshSection();
      document.querySelector("cart-overlay")?.open();
    } catch (err) {
      console.error("Remove from cart failed:", err);
    }
  }

  async _refreshSection() {
    const header = document.querySelector(".header-section");
    if (!header) return;
    const sectionId = header.dataset.shopifySectionId || header.id?.replace("shopify-section-", "");
    if (!sectionId) return;
    const res = await fetch(`${window.location.pathname}?sections=${sectionId}`);
    if (!res.ok) return;
    const json = await res.json();
    const html = json[sectionId];
    if (!html) return;
    header.innerHTML = new DOMParser().parseFromString(html, "text/html").body.firstElementChild.innerHTML;
  }

  _checkUrlParam() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("open_cart") === "true") {
      params.delete("open_cart");
      const cleanUrl = params.toString() ? `${window.location.pathname}?${params}` : window.location.pathname;
      history.replaceState({}, "", cleanUrl);
      requestAnimationFrame(() => this.open());
    }
  }
}

if (!customElements.get("cart-overlay")) {
  customElements.define("cart-overlay", CartOverlay);
}
